import React from 'react';
import {
  Container,
} from 'reactstrap';

import FormValidator from '../../../utils/FormValidator';
import validationConfig from './validationConfig';
import FormContext from '../FormContext';
import InputGroupClass from '../InputGroupClass';

import ValidatedTextInput from '../ScoringRequestForm.validatedTextInput';

const formGroupFieldNames = [
  'jobTitle', 'employerName',
];

class LoanInputGroup extends InputGroupClass {
  constructor(props) {
    super(props);

    super.formGroupFieldNames = formGroupFieldNames;
    super.skipValidationOnGroupIfEmpty = false;

    this.validator = new FormValidator(validationConfig);
  }

  render() {
    return (
      <FormContext.Consumer>
        {(context) => {
          const { dataTreeKey } = this.props;
          const previousState = context[dataTreeKey];
          this.userInputValues = previousState;
          return (
            <div className="deal-information-input-group">
              <h4>Employment Information</h4>
              <div className="form-group-wrapper">
                <Container>
                  <ValidatedTextInput
                    /* eslint-disable-next-line react/jsx-props-no-spreading */
                    {...this.props}
                    name="jobTitle"
                    id="EmployerJobTitle"
                    label="Job Title"
                    valid={!this.state.jobTitleFieldInvalid}
                    validationMessage={this.state.jobTitleFieldValidationMessage}
                    type="text"
                    value={previousState.jobTitle || ''}
                    onChange={this.generateFieldOnChangeEvent(context, dataTreeKey)}
                  />
                  <ValidatedTextInput
                    /* eslint-disable-next-line react/jsx-props-no-spreading */
                    {...this.props}
                    name="employerName"
                    id="EmployerEmployerName"
                    label="Employer"
                    valid={!this.state.employerNameFieldInvalid}
                    validationMessage={this.state.employerNameFieldValidationMessage}
                    type="text"
                    value={previousState.employerName || ''}
                    onChange={this.generateFieldOnChangeEvent(context, dataTreeKey)}
                  />
                </Container>
              </div>
            </div>
          );
        }}
      </FormContext.Consumer>
    );
  }
}

export default LoanInputGroup;
